/* QBounce contact page + membership cancellation page (sections/qb-contact-page.liquid), 2026-10-18.
   - support desk: "Open now" / "Closed now" from the store's hours in the store's time zone, when it closes or next
     opens, and the hours in the visitor's own time when that differs; refreshed every minute;
   - copy the email address (button shown only where the clipboard can be written);
   - topic chips (a link can pick one: ?topic=returns-and-refunds): the picked topic shows its shortcut, asks for the order number if set (the field is only sent then),
     and can write its message into the message field (only over an empty field or another topic's message);
   - steps (cancellation): each lights up when its part of the form is done; the line between them fills;
   - send: a small ball dribbles on the button while the message is on its way;
   - cards below the opener rise in once they reach the screen.
   Reduced motion: no rise, no ball (CSS). */
(function () {
  'use strict';

  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var SHORT = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  /* ---- hours ------------------------------------------------------------------------------------ */
  function zoned(date, tz) {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: tz, weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
    }).formatToParts(date);
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return {
      day: SHORT[o.weekday], y: +o.year, mo: +o.month, d: +o.day,
      h: +o.hour % 24, mi: +o.minute
    };
  }

  /* the instant of hour H on the zoned calendar day (y, mo, d) in tz */
  function instant(z, hour, tz) {
    var guess = Date.UTC(z.y, z.mo - 1, z.d, hour, 0);
    var back = zoned(new Date(guess), tz);
    var shown = Date.UTC(back.y, back.mo - 1, back.d, back.h, back.mi);
    return new Date(guess - (shown - guess));
  }

  function hourText(h) {
    var hh = h % 24;
    var ap = hh < 12 ? 'AM' : 'PM';
    var n = hh % 12 === 0 ? 12 : hh % 12;
    return n + ap;
  }

  function initHours(card) {
    var tz = card.getAttribute('data-tz');
    if (!tz || !window.Intl) return;
    try { zoned(new Date(), tz); } catch (e) { return; }
    var open = parseInt(card.getAttribute('data-open'), 10);
    var close = parseInt(card.getAttribute('data-close'), 10);
    var weekends = card.getAttribute('data-weekends') === 'true';
    var short = card.getAttribute('data-tz-short') || '';
    var status = card.querySelector('[data-qb-ct-status]');
    var text = card.querySelector('[data-qb-ct-status-text]');
    var sub = card.querySelector('[data-qb-ct-status-sub]');
    var local = card.querySelector('[data-qb-ct-local]');
    if (!status || !text || isNaN(open) || isNaN(close)) return;

    function workday(d) { return weekends || (d >= 1 && d <= 5); }
    function suffix() { return short ? ' ' + short : ''; }

    function update() {
      var now = new Date();
      var z = zoned(now, tz);
      var mins = z.h * 60 + z.mi;
      var isOpen = workday(z.day) && mins >= open * 60 && mins < close * 60;
      status.classList.toggle('is-open', isOpen);
      text.textContent = card.getAttribute(isOpen ? 'data-open-text' : 'data-closed-text');
      var line;
      if (isOpen) {
        line = card.getAttribute('data-closes-text') + ' ' + hourText(close) + suffix();
      } else {
        var ahead = 0;
        if (!(workday(z.day) && mins < open * 60)) {
          ahead = 1;
          while (ahead < 8 && !workday((z.day + ahead) % 7)) ahead++;
        }
        var when = ahead === 0 ? '' : ahead === 1 ? 'tomorrow ' : DAYS[(z.day + ahead) % 7] + ' ';
        line = card.getAttribute('data-opens-text') + ' ' + when + hourText(open) + suffix();
      }
      if (sub) sub.textContent = line;

      /* the same hours in the visitor's time, when that is a different clock */
      if (local) {
        var a = instant(z, open, tz);
        var b = instant(z, close, tz);
        var mine = zoned(a, Intl.DateTimeFormat().resolvedOptions().timeZone || tz);
        if (mine.h !== open || mine.mi !== 0) {
          var f = { hour: 'numeric', minute: '2-digit' };
          local.textContent = card.getAttribute('data-local-text') + ': ' +
            a.toLocaleTimeString([], f) + ' - ' + b.toLocaleTimeString([], f);
          local.classList.remove('is-off');
        } else {
          local.classList.add('is-off');
        }
      }
    }

    update();
    setInterval(function () {
      if (!document.hidden) update();
    }, 60000);
  }

  /* ---- copy the email ----------------------------------------------------------------------------- */
  function initCopy(btn) {
    if (!navigator.clipboard || !window.isSecureContext) return;
    btn.hidden = false;
    var label = btn.getAttribute('aria-label');
    var done = btn.querySelector('[data-qb-ct-copied]');
    var timer = null;
    btn.addEventListener('click', function () {
      navigator.clipboard.writeText(btn.getAttribute('data-qb-ct-copy')).then(function () {
        btn.classList.add('is-copied');
        btn.setAttribute('aria-label', done ? done.textContent : 'Copied');
        clearTimeout(timer);
        timer = setTimeout(function () {
          btn.classList.remove('is-copied');
          btn.setAttribute('aria-label', label);
        }, 1800);
      });
    });
  }

  /* ---- the form ------------------------------------------------------------------------------------ */
  function initForm(root) {
    var form = root.querySelector('form.qb-ct-form');
    if (!form) return;
    /* after sending, every step is done (the fields are gone) */
    var card = root.querySelector('[data-qb-ct-card]');
    var radios = Array.prototype.slice.call(form.querySelectorAll('[data-qb-ct-topic]'));
    var hints = Array.prototype.slice.call(root.querySelectorAll('[data-qb-ct-hint]'));
    var orderWrap = form.querySelector('[data-qb-ct-order]');
    var order = orderWrap && orderWrap.querySelector('input');
    var body = form.querySelector('[data-qb-ct-watch="message"]');
    var name = form.querySelector('[data-qb-ct-watch="name"]');
    var email = form.querySelector('[data-qb-ct-watch="email"]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-qb-ct-step]'));
    var stepList = root.querySelector('[data-qb-ct-steps]');
    var send = form.querySelector('[data-qb-ct-send]');
    var done = root.querySelector('[data-qb-ct-done]');
    var prefills = radios.map(function (r) { return r.getAttribute('data-message') || ''; }).filter(Boolean);
    var sent = false;

    if (stepList) stepList.style.setProperty('--n', steps.length);

    function updateSteps() {
      if (!steps.length) return;
      var lastOn = -1;
      var chain = true;
      steps.forEach(function (s, i) {
        var w = s.getAttribute('data-qb-ct-step');
        var on = false;
        if (w === 'contact') on = !!(name && name.value.trim() && email && email.value.trim() && email.checkValidity());
        else if (w === 'message') on = !!(body && body.value.trim().length >= 3);
        else if (w === 'send') on = sent;
        if (done) on = true;
        s.classList.toggle('is-on', on);
        if (on && chain) lastOn = i;
        else chain = false;
      });
      if (stepList) {
        var p = steps.length > 1 ? Math.max(0, lastOn) / (steps.length - 1) : 0;
        stepList.style.setProperty('--p', p.toFixed(3));
      }
      if (card) card.classList.toggle('is-active', lastOn >= 0);
    }

    function pick(radio, fromUser) {
      var id = radio ? radio.getAttribute('data-qb-ct-topic') : '';
      hints.forEach(function (h) {
        var show = h.getAttribute('data-qb-ct-hint') === id;
        if (show && !h.hidden) return;
        h.hidden = !show;
      });
      var wantsOrder = !!(radio && radio.hasAttribute('data-order'));
      form.classList.toggle('has-order', wantsOrder);
      if (order) order.disabled = !wantsOrder;
      var msg = radio && radio.getAttribute('data-message');
      if (msg && body) {
        var cur = body.value.trim();
        if (!cur || prefills.indexOf(cur) !== -1) body.value = msg;
      } else if (fromUser && body && prefills.indexOf(body.value.trim()) !== -1) {
        body.value = '';
      }
      updateSteps();
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) pick(r, true); });
    });
    /* a link can pick the topic: ?topic=returns-and-refunds (the topic's label, lower case, words joined by -) */
    var want = (location.search.match(/[?&]topic=([^&]+)/) || [])[1];
    if (want) {
      want = decodeURIComponent(want).toLowerCase();
      radios.forEach(function (r) {
        var key = r.value.toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        if (key === want) r.checked = true;
      });
    }
    var checked = radios.filter(function (r) { return r.checked; })[0];
    if (checked) pick(checked, false);
    else if (order) order.disabled = true;

    [name, email, body].forEach(function (el) {
      if (el) el.addEventListener('input', updateSteps);
    });
    updateSteps();

    form.addEventListener('submit', function () {
      if (form.checkValidity && !form.checkValidity()) return;
      sent = true;
      updateSteps();
      if (send) {
        send.classList.add('is-busy');
        send.setAttribute('aria-busy', 'true');
      }
    });
    /* coming back to the page from the browser's cache */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || !send) return;
      sent = false;
      send.classList.remove('is-busy');
      send.removeAttribute('aria-busy');
      updateSteps();
    });
  }

  /* ---- rise in ------------------------------------------------------------------------------------- */
  function initReveal(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll('[data-qb-ct-reveal]'));
    if (!els.length || !('IntersectionObserver' in window)) return;
    root.classList.add('qb-ct-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        entry.target.classList.add('is-in');
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init(root) {
    if (!root || root.dataset.qbCtReady) return;
    root.dataset.qbCtReady = '1';
    var hours = root.querySelector('[data-qb-ct-hours]');
    if (hours) initHours(hours);
    root.querySelectorAll('[data-qb-ct-copy]').forEach(initCopy);
    initForm(root);
    initReveal(root);
  }

  function boot() {
    document.querySelectorAll('[data-qb-ct]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
